import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import SurveyViewer from '../components/SurveyViewer';
import { fetchSurveyById, checkUserResponse } from '../utils/serverComm';
import { auth } from '../firebase-config';

function Survey() {
  const { id } = useParams();
  const [survey, setSurvey] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [hasResponded, setHasResponded] = useState(false);

  useEffect(() => {
    const fetchSurvey = async () => {
      try {
        const data = await fetchSurveyById(id);
        setSurvey(data);
        
        // Only check for existing response if user is authenticated
        if (auth.currentUser) {
          const hasExistingResponse = await checkUserResponse(id);
          setHasResponded(hasExistingResponse);
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchSurvey();
  }, [id]);

  if (loading) {
    return (
      <div className="container mx-auto p-6">
        <div className="text-center">Loading survey...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="container mx-auto p-6">
        <div className="text-red-500">Error: {error}</div>
      </div>
    );
  }

  if (isSubmitted || hasResponded) {
    return (
      <div className="container mx-auto p-6">
        <div className="text-center text-xl">Thank you for taking our survey.</div>
      </div>
    );
  }

  return (
    <div className="container mx-auto p-6">
      <SurveyViewer 
        title={survey.title} 
        questions={survey.questions} 
        surveyId={survey.surveyId}
        onSubmitSuccess={() => setIsSubmitted(true)}
      />
    </div>
  );
}

export default Survey; 